module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Maerstetten-Ottoberg_horizontal-41028bb9c957317e52706d08e0bd84b8.png";